import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card flex flex-column justify-content-between h-full" }
const _hoisted_2 = { class: "flex align-items-center justify-content-between mb-3" }
const _hoisted_3 = {
  key: 0,
  class: "text-gray-300"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "flex align-items-center gap-3 mb-3" }
const _hoisted_8 = { class: "col-3 px-0 py-0" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "col-9" }
const _hoisted_11 = { class: "font-medium" }
const _hoisted_12 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          (_ctx.creative.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.creative.id), 1))
            : _createCommentVNode("", true),
          (_ctx.creative.country)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.creative.country.alpha2_code), 1))
            : _createCommentVNode("", true),
          (_ctx.creative.bid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$n(_ctx.creative.bid, 'bid')), 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.creative.click_url)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "block",
              href: _ctx.creative.click_url,
              target: "_blank"
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "pi pi-external-link" }, null, -1)
            ]))], 8, _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            class: "w-full h-full border-round-lg",
            src: _ctx.creative.icon_url,
            alt: "Icon",
            onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onImageError && _ctx.onImageError(...args)))
          }, null, 40, _hoisted_9)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.creative.title), 1),
          (_ctx.creative.description)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.creative.description), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("img", {
        class: "block mb-3 w-full border-round-lg",
        src: _ctx.creative.image_url,
        alt: "Image",
        onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImageError && _ctx.onImageError(...args)))
      }, null, 40, _hoisted_13)
    ]),
    _createElementVNode("a", {
      class: "block",
      href: `/feeds/${_ctx.creative.feed_id}`,
      target: "_blank"
    }, [
      _renderSlot(_ctx.$slots, "feed-name", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.creative.feed?.compiled_name || `#${_ctx.creative.feed_id}`), 1)
      ])
    ], 8, _hoisted_14)
  ]))
}